var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncidentHoliday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14zM7.87 7.82l-1.48 4.305H2.224c-.538 0-.975.462-.975 1.031 0 .19.146.344.325.344h11.05a.33.33 0 0 0 .326-.324c0-.59-.437-1.051-.975-1.051H7.77l1.32-3.836-1.221-.47zm3.974-4.021c.127.349.218.744.267 1.187.116 1.071-.028 2.323-.384 3.586l2.084.803a.324.324 0 0 0 .437-.303c.05-2.059-.85-4.03-2.404-5.273zM9.789 2.797c-1.177 0-2.605 1.488-3.51 3.677l4.846 1.866c.726-2.608.378-4.976-.866-5.455a1.327 1.327 0 0 0-.47-.088zM3.444 4.908a.348.348 0 0 0 .15.53l2.074.803c.714-1.754 1.752-3.103 2.824-3.733-1.948-.105-3.835.794-5.048 2.4z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidentHoliday);
export default __webpack_public_path__ + "static/media/incident-holiday.1a47bb165576fcbbdae12a82c1f8dd04.svg";
export { ForwardRef as ReactComponent };